import { render, staticRenderFns } from "./patient-exists-dialog.vue?vue&type=template&id=052f2361&scoped=true&lang=pug&"
import script from "./patient-exists-dialog.vue?vue&type=script&lang=ts&"
export * from "./patient-exists-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./patient-exists-dialog.vue?vue&type=style&index=0&id=052f2361&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052f2361",
  null
  
)

export default component.exports